export function hasFeatureInSubscription(subscription, featureKey) {
  if (!subscription || !featureKey) return false;

  // Match featureKey against `name` in services[] (case-insensitive)
  if (Array.isArray(subscription.services)) {
    return subscription.services.some(
      (service) => service.name?.toLowerCase() === featureKey.toLowerCase()
    );
  }

  return false;
}
